module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("6zPtE"))).then(() => parcelRequire('iAqDU'));